import React from 'react';
import {injectIntl} from 'react-intl';
import getRouteByName from 'getRouteByName';
import SearchForm from '@Components/SearchForm';
import Breadcrumbs from '@Components/Breadcrumbs';
import Icon from '@Components/Icon';

const SearchHeader = ({intl, searchParams, title, subtitle, subscribeLink}) => {
  const jobSearchUrl = getRouteByName('search').url;

  return (
    <>
      <div className="header header--search-alternative mvp-header--search-alternative header--text bg-brand--dark-blue">
        <div className="wrapper">
          <Breadcrumbs jobSearchUrl={jobSearchUrl}/>
          <div className="header__content header__content--full-width content-block" data-rs-input-highlight-wrapper={true}>
            {title && <h1 className="content-block__title pt-xs l:pt-l">
              <span className='content-block__title-top'>{title}</span>
            </h1>}
            {subtitle && <p className="content-block__description">
              {subtitle}
            </p>}
            <div className="search-form form-groups form-groups--row">
              <SearchForm searchParams={searchParams} />
              {
                subscribeLink ?
                  <div className="get-job-alerts">
                    <div className="get-job-alerts__text-default">
                      <span className="icon icon--inline">
                        <Icon type="bell"/>
                      </span>
                      <span>
                        <a href="#"
                          data-rs-modal-trigger="get-job-alerts">{intl.formatMessage({id: 'SearchHeaderSubscribeLink'})}</a>
                      </span>
                    </div>
                  </div> : null
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(SearchHeader);
